import { Link } from "react-router-dom";
import { LOGO_URL, DIVISIONI } from "@/data/content";
import { useLang } from "@/i18n";

export const Footer = () => {
  const { t } = useLang();
  return (
    <footer data-testid="site-footer" className="bg-[#080808] border-t border-[#C6A45D]/15">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16 lg:py-20">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          <div>
            <img src={LOGO_URL} alt="Billions Group" className="h-14 w-auto mb-6" />
            <p className="text-sm text-[#A5A5A5] leading-relaxed max-w-xs">
              {t("footer.tagline")}
            </p>
            <p className="mt-6 text-xs text-[#A5A5A5]/70 leading-relaxed max-w-xs">
              BILLIONS GROUP LTD
              <br />
              Viale Tsar Boris III n° 85, Sofia
              <br />
              P.I. 208789980
            </p>
          </div>
          <div>
            <p className="eyebrow mb-6">{t("footer.units")}</p>
            <ul className="space-y-3">
              {DIVISIONI.map((d) => (
                <li key={d.id}>
                  <span className="text-sm text-[#A5A5A5] hover:text-[#C6A45D] transition-colors duration-300 cursor-default">
                    Billions {d.nome}
                  </span>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <p className="eyebrow mb-6">{t("footer.group")}</p>
            <ul className="space-y-3">
              <li>
                <Link to="/chi-siamo" data-testid="footer-link-chi-siamo" className="text-sm text-[#A5A5A5] hover:text-[#C6A45D] transition-colors duration-300">
                  {t("footer.chiSiamo")}
                </Link>
              </li>
              <li>
                <Link to="/diventa-partner" data-testid="footer-link-diventa-partner" className="text-sm text-[#A5A5A5] hover:text-[#C6A45D] transition-colors duration-300">
                  {t("footer.diventaPartner")}
                </Link>
              </li>
              <li>
                <Link to="/contatti" data-testid="footer-link-contatti" className="text-sm text-[#A5A5A5] hover:text-[#C6A45D] transition-colors duration-300">
                  {t("footer.contatti")}
                </Link>
              </li>
              <li>
                <Link to="/area-riservata" data-testid="footer-link-area-riservata" className="text-sm text-[#A5A5A5] hover:text-[#C6A45D] transition-colors duration-300">
                  {t("footer.areaRiservata")}
                </Link>
              </li>
              <li>
                <Link to="/magazine" data-testid="footer-link-magazine" className="text-sm text-[#A5A5A5] hover:text-[#C6A45D] transition-colors duration-300">
                  {t("footer.magazine")}
                </Link>
              </li>
              <li>
                <Link to="/press" data-testid="footer-link-press" className="text-sm text-[#A5A5A5] hover:text-[#C6A45D] transition-colors duration-300">
                  {t("footer.press")}
                </Link>
              </li>
              <li>
                <Link to="/privacy" data-testid="footer-link-privacy" className="text-sm text-[#A5A5A5] hover:text-[#C6A45D] transition-colors duration-300">
                  {t("footer.privacy")}
                </Link>
              </li>
            </ul>
          </div>
        </div>
        <div className="gold-line mt-16 mb-8 opacity-60" />
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-[#A5A5A5]/70 tracking-wider">
            © {new Date().getFullYear()} BILLIONS GROUP LTD · P.I. 208789980 · {t("footer.rights")}
          </p>
          <p className="text-xs tracking-[0.3em] uppercase text-[#C6A45D]/70">
            Italian Excellence · Global Vision
          </p>
        </div>
      </div>
    </footer>
  );
};
